.root {
    border-width: 1px;
    border-style: solid;
}

.label {
    line-height: 1;
}